import { Component, OnDestroy, OnInit } from '@angular/core';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { Router } from '@angular/router';

@Component({
  selector: 'app-buyflow-featured-locations',
  templateUrl: './buyflow-featured-locations.component.html',
  styleUrls: ['./buyflow-featured-locations.component.scss'],
})
export class BuyflowFeaturedLocationsComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  waterBodies: WaterBody[] = [];
  subs: Subscription[] = [];

  constructor(
    private readonly waterBodyDAO: WaterBodyDAO,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.initAsyncData();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  navTo(wb: WaterBody): void {
    this.router.navigate(['rental-location-map/' + wb.vanityUrl]);
  }

  private initAsyncData(): void {
    const sub = this.waterBodyDAO.getFeaturedBodies().subscribe((wbs) => {
      this.waterBodies = wbs;
    });
    this.subs.push(sub);
  }
}
